'use strict';
module.exports = require('./validate');
module.exports.isBSN = require('./helpers/isBSN');
module.exports.isEmailAddress = require('./helpers/isEmailAddress');
module.exports.isISODate = require('./helpers/isISODate');
module.exports.isPhoneNumber = require('./helpers/isPhoneNumber');
module.exports.isPostalCode = require('./helpers/isPostalCode');
module.exports.isSepaCountryIban = require('./helpers/isSepaCountryIban');
